module.exports = __webpack_public_path__ + "static/logo-suomiareena-e78138c6cd0e38694807d6bd7ab4905e.png";